import { axios, path } from './config';
import qs from 'qs';
import { campaignTypes, textCount } from 'appConstants';
import { UPDATEISRENGAGEMENT } from 'components/Campaigns/constants';

const paramStruc = ({
  minDaysLastContacted: minDays,
  maxDaysLastContacted: maxDays,
  tagsData,
  message,
  reEngagementUrl,
  emailFrom,
  timeInISO,
  timeZone,
}) => {
  const candidateQuery = {
    lastContacted: {
      minDays,
      maxDays,
    },
    and: [
      {
        filter: { sqlField: 'status', type: 'Equals', value: 'active' },
      },
    ],
  };
  if (tagsData) {
    tagsData.forEach((value) =>
      candidateQuery.and.push({
        filter: { sqlField: 'fullTags.name', type: 'Equals', value: value.name },
      }),
    );
  }

  const reengagementMessage = {
    text: message,
    focusTrigger: false,
    url: reEngagementUrl,
    messageError: '',
    urlError: '',
    charsLeftResult: textCount - message.length,
    from: emailFrom,
    fromItemError: '',
    sendAs: emailFrom.info,
    sendAt: timeInISO,
    timeZone,
  };
  return {
    candidateQuery,
    reengagementMessage,
  };
};

export function addCampaignApi({
  campaignName,
  isReengagement,
  code,
  url,
  autoResponse,
  isAri,
  sequence = {},
  minDaysLastContacted,
  maxDaysLastContacted,
  tagsData,
  message,
  reEngagementUrl,
  emailFrom,
  timeInISO,
  timeZone,
}) {
  const { sequenceDefinitionId = '', displayName = '' } = sequence;

  const params = {
    name: campaignName,
    type: isReengagement ? campaignTypes.REENGAGEMENT : campaignTypes.STANDARD,
  };

  if (code) {
    params.code = code;
  }
  if (url) {
    params.url = url;
  }
  if (autoResponse) {
    params.auto_response = autoResponse;
  }
  if (isAri) {
    params.outbound_ari_name = displayName;
    params.sequence_id = sequenceDefinitionId;
  }
  if (isReengagement) {
    const paramValue = paramStruc({
      minDaysLastContacted,
      maxDaysLastContacted,
      tagsData,
      message,
      reEngagementUrl,
      emailFrom,
      timeInISO,
      timeZone,
    });
    params.candidate_query = paramValue.candidateQuery;
    params.reengagement_message = paramValue.reengagementMessage;
  }

  return axios.post(`${path.ADD_CAMPAIGN}`, null, { params });
}

export function getSequencesARI() {
  return axios.get(path.ARI_SEQUENCES);
}

export function updateCampaignApi({
  campaignName,
  isReengagement,
  code,
  url,
  status,
  autoResponse,
  isAri,
  sequence = {},
  jobId,
  minDaysLastContacted,
  maxDaysLastContacted,
  tagsData,
  message,
  reEngagementUrl,
  emailFrom,
  timeInISO,
  timeZone,
  isEnabled,
  requestType,
}) {
  const { sequenceDefinitionId = '', displayName = '' } = sequence;

  const params = {
    name: campaignName,
    type: isReengagement ? campaignTypes.REENGAGEMENT : campaignTypes.STANDARD,
    job_id: jobId,
    status,
    is_enabled: isEnabled,
  };

  if (code) {
    params.code = code;
  }
  if (url) {
    params.url = url;
  }
  if (autoResponse) {
    params.auto_response = autoResponse;
  }
  if (isAri) {
    params.outbound_ari_name = displayName;
    params.sequence_id = sequenceDefinitionId;
  } else {
    params.sequence_id = '<REMOVE>';
  }
  if (isReengagement && requestType === UPDATEISRENGAGEMENT) {
    const paramValue = paramStruc({
      minDaysLastContacted,
      maxDaysLastContacted,
      tagsData,
      message,
      reEngagementUrl,
      emailFrom,
      timeInISO,
      timeZone,
    });
    params.candidate_query = paramValue.candidateQuery;
    params.reengagement_message = paramValue.reengagementMessage;
  }
  const formData = new FormData();

  formData.append('job_id', jobId);

  return axios.post(`${path.UPDATE_CAMPAIGN}`, null, { params }, formData);
}

export function saveMessageTemplate({ code, name, text, templateId, shareTemplate, type }) {
  const params = {
    code,
    name,
    text,
    share_template: shareTemplate,
    type,
  };
  if (templateId) {
    params.message_template_id = templateId;
  }

  return axios.post(path.CUSTOMER_INT_ADD_UPDATE_TEMPLATE + qs.stringify({ ...params }));
}

export function removeIntegrationMessageTemplate(templateId) {
  return axios.post(
    path.CUSTOMER_INT_REMOVE_TEMPLATE + qs.stringify({ message_template_id: templateId }),
  );
}

export function fetchCandidateJobMax({ jobId }) {
  return axios.get(path.CANDIDATE_JOB_MAX, { params: { job_id: jobId } });
}
